<div class="import-create">
  <form class="form form_crm" [formGroup]="formGroup" novalidate>
    <div class="row no-gutters gutters-4 align-items-center">
      <div class="col-6 col-sm-5 col-md-6">
        <app-material-input formControlName="url" [placeholder]="'https://site.ru/'" [require]="true">
          URL фида
        </app-material-input>
      </div>
      <div class="col-6 col-sm-4 col-md-4">
        <app-material-select2
          formControlName="specification_id"
          [placeholder]="'-- Не выбрано --'"
          [caption]="'Формат'"
          [require]="true">
          <option [value]="''">-- Не выбрано --</option>
          @for (format of format_list; track format) {
            <option
            [value]="+format.id">{{format.caption}}</option>
          }
        </app-material-select2>
      </div>
      <div class="col-12 col-sm-3 col-md-2">
        <button (click)="saveForm()" type="button" [disabled]="loading"
          class="button pull-right" [ngClass]="{'button_disabled': loading}">
          Создать
        </button>
      </div>
    </div>
    <div class="row no-gutters gutters-4 align-items-center mt-2">
      <div class="col">
        @if (error) {
          <div class="c-red text-normal">
            {{error}}
          </div>
        }
      </div>
      <div class="col-auto">
        @if (loading) {
          <i class="fa fa-spin fa-spinner mr-2"></i>
          <span class="pull-right text-normal">Подождите, происходит анализ фида…</span>
        }
      </div>
      <div class="col-12 px-4">
        <app-import-analyze
          [feedUrl]="formGroup.get('url').value"
          (onLoading)="analyzeLoading($event)"
          (onError)="analyzeError($event)"
          />
      </div>
    </div>
  </form>
</div>
